import { render, staticRenderFns } from "./JClock.vue?vue&type=template&id=b5633c1a&scoped=true&"
import script from "./JClock.vue?vue&type=script&lang=js&"
export * from "./JClock.vue?vue&type=script&lang=js&"
import style0 from "./JClock.vue?vue&type=style&index=0&id=b5633c1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5633c1a",
  null
  
)

export default component.exports